import { FC } from 'react'
import styled from 'styled-components'
import { HorizontalTitledProductsSlider } from '@/components/organisms/productsSlider'
import {
  ShowProductModal,
  withProductDetailPopup
} from '@/HOC/withProductDetailPopup'
import {
  HorizontalTitledProductsSliderFetcher,
  TitleType
} from '@/components/organisms/productsSlider/horizontalTitledProductsSlider'
import useGraphQl from 'hooks/useGraphQl'
import type { Sdk } from '@/network/graphql.g'
import { useUser } from '@/providers/userProvider'
import { convertAPIProductToProduct } from '@/types/bridgeProduct'
import useTranslation from 'next-translate/useTranslation'
import Link from '@/components/atoms/link'
import { Routes } from '@/core/routes'
import { Flex } from '@/components/atoms/Grid'
import { BigAccentButton } from '@/components/atoms/button'

type SummerRecommendedSliderProps = {
  showProductModal?: ShowProductModal
}

const SummerRecommendedSlider: FC<SummerRecommendedSliderProps> = ({
  showProductModal
}) => {
  const { t } = useTranslation('common')
  const { request } = useGraphQl()
  const { isLoggedIn } = useUser()
  const bestsellersFetcher =
    async (): Promise<HorizontalTitledProductsSliderFetcher> => {
      const result = await request(
        (sdk: Sdk) => ({
          method: sdk.getHomeBestsellersProductsNew,
          requestHeaders: isLoggedIn
            ? {}
            : {
                'x-cachable': '1'
              }
        }),
        true
      )
      return {
        list: result.response?.recommended?.[0]?.listName,
        products:
          result.response?.recommended?.[0]?.products?.map((item) =>
            convertAPIProductToProduct(item)
          ) ?? [],
        algorithm: result.response?.recommended?.[0]?.algorithm
      }
    }

  return (
    <>
      <StyledWrapper>
        <HorizontalTitledProductsSlider
          action={showProductModal}
          titleType={TitleType.bestSeller}
          slideItemsCount={{ desktop: 5, tablet: 3, mobile: 2 }}
          fetcher={bestsellersFetcher}
          swrKey={'recommended/Bestsellers'}
          useCache={false}
        />
      </StyledWrapper>
      <StyledLink href={Routes.top100}>
        <StyledSummerButton width={150} title={t('BlackFriday.showMore')} />
      </StyledLink>
    </>
  )
}

export default withProductDetailPopup(SummerRecommendedSlider)

const StyledWrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;
  padding-bottom: 25px;
`
const StyledSummerButton = styled(BigAccentButton)`
  text-align: center;
  background-color: ${(props) => props.theme.colors.summerBackgroundButton};
  color: ${(props) => props.theme.colors.onBackground};
  margin-bottom: 15px;
  margin-bottom: 50px;
  border: 1px solid black;
`

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
`
